import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  compilation() {
    return faker.datatype.boolean();
  },

  country() {
    return '';
  },

  headline() {
    return faker.commerce.product();
  },

  releaseDate() {
    return faker.date.past();
  },

  productPhysId() {
    return faker.random.numeric(6);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(product, server) {
    product.update({
      assetId: server.create('asset'),
      assetId1: server.create('asset'),
      categoryId: server.create('category', 'productConfiguartion'),
      categoryId1: server.create('category', 'productFamily'),
      categoryId2: server.create('category', 'productCategory'),
      categoryId3: server.create('category', 'productSubCategory'),
      categoryId4: server.create('category', 'productDeliveryState'),
      // contributors: server.createList('product-contributor', 1),
      customShops: server.createList('custom-shop', 4),
      externalValues: server.createList('external-value', 4),
      internationalLabel: server.create('label'),
      label: server.create('label'),
      additionalCategories: server.createList('category', 3, 'mixedCategories'),
      productPhysCategoryId1: server.create('category', 'productConfiguartion'),
      productElements: server.createList('product-element', 1),
      shortUrls: server.createList('short-url', 1),
      videos: server.createList('asset', 1),
    });
  },
});
